var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCalendarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80339 0.25C5.00388 0.25 5.19617 0.329018 5.33794 0.46967C5.47971 0.610322 5.55936 0.801088 5.55936 1V2.5H14.631V1C14.631 0.801088 14.7106 0.610322 14.8524 0.46967C14.9942 0.329018 15.1864 0.25 15.3869 0.25C15.5874 0.25 15.7797 0.329018 15.9215 0.46967C16.0633 0.610322 16.1429 0.801088 16.1429 1V2.5H16.8989C17.7009 2.5 18.47 2.81607 19.0371 3.37868C19.6042 3.94129 19.9228 4.70435 19.9228 5.5V16.75C19.9228 17.5456 19.6042 18.3087 19.0371 18.8713C18.47 19.4339 17.7009 19.75 16.8989 19.75H3.29145C2.48947 19.75 1.72034 19.4339 1.15325 18.8713C0.586164 18.3087 0.267578 17.5456 0.267578 16.75V5.5C0.267578 4.70435 0.586164 3.94129 1.15325 3.37868C1.72034 2.81607 2.48947 2.5 3.29145 2.5H4.04742V1C4.04742 0.801088 4.12707 0.610322 4.26884 0.46967C4.41061 0.329018 4.60289 0.25 4.80339 0.25ZM18.4108 9.25C18.4108 8.85218 18.2515 8.47064 17.968 8.18934C17.6844 7.90804 17.2999 7.75 16.8989 7.75H3.29145C2.89046 7.75 2.50589 7.90804 2.22235 8.18934C1.93881 8.47064 1.77951 8.85218 1.77951 9.25V16.75C1.77951 17.1478 1.93881 17.5294 2.22235 17.8107C2.50589 18.092 2.89046 18.25 3.29145 18.25H16.8989C17.2999 18.25 17.6844 18.092 17.968 17.8107C18.2515 17.5294 18.4108 17.1478 18.4108 16.75V9.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCalendarIcon);
export default __webpack_public_path__ + "static/media/ActiveCalendarIcon.b4e6a5afb5b932e2a7542f303a6c99dd.svg";
export { ForwardRef as ReactComponent };